import { Controller } from 'stimulus'
export default class extends Controller {
  static targets = ['modal']

  show() {
    this.dispatch('modal:show', { prefix: false, target: this.modalTarget })
  }

  submit() {
    this.element.dataset.signed = true
    this.dispatch('modal:hide', { target: this.modalTarget, prefix: false })
    this.dispatch('signed')
  }

  cancel() {
    this.dispatch('cancelled')
  }
}
